module.exports = __webpack_public_path__ + "static/media/step2.1158ca74.png";